import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { useTranslations } from "next-intl";
import { WidgetSearchForm } from "../SearchFormLegacy";
import { Wrapper, LogoWrapper, Logo } from "./WidgetStage.styles";
/**
 * Rendered sizes:
 * - 250x250
 * - 300x250
 * - 300x400
 * - 300x600
 * - 320x480
 * - 800x250
 * - 970x250
 * @see https://silvertours.atlassian.net/browse/DGN-1785
 * @see https://silvertours.atlassian.net/browse/DGN-1784
 */ var WidgetStage = function(param) {
    var baseImageUrl = param.baseImageUrl;
    var t = useTranslations("features.stageLegacy.stage.searchForm");
    return /*#__PURE__*/ _jsxs(Wrapper, {
        baseImageUrl: baseImageUrl,
        children: [
            /*#__PURE__*/ _jsx(WidgetSearchForm, {}),
            /*#__PURE__*/ _jsx(LogoWrapper, {
                id: "logo",
                children: /*#__PURE__*/ _jsx(Logo, {
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "".concat(baseImageUrl).concat(t("widget.logo.src")),
                        alt: t("widget.logo.alt"),
                        loading: "lazy"
                    })
                })
            })
        ]
    });
};
export { WidgetStage };
